import React from 'react';
import PropTypes from 'prop-types';

import CurrencyInput from '../../../common/currencyInput';
import Input from '../../../common/input';
import * as shapes from '../../shapes';
import { trimFunction } from '../../../common/trimData';
import Select from '../../../common/select';
import { fullName } from '../../../common/helpers/users';
import { t } from '../../../../modules/infra/i18n';

const Form = ({
  pristine,
  submitting,
  valid,
  handleSubmit,
  barbers,
  charge,
  isUnassignedChargeAvailable,
}) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="u-pt">
        <form>
          <fieldset disabled={submitting}>
            <div className="layout u-mt-">
              <div className="layout__item u-1/3-large-and-up">
                <span className="c-label-new u-inline-block">{t('register:custom_charge.form.description_label')}</span>
                <Input
                  className="c-input c-input--white"
                  name="desc"
                  type="text"
                  placeholder={t('register:custom_charge.form.description_placeholder')}
                />
              </div>
              <div className="layout__item u-1/3-large-and-up">
                <span className="c-label-new u-inline-block">{t('register:custom_charge.form.price_label')}</span>
                <CurrencyInput
                  className="c-input c-input--white"
                  placeholder={t('register:custom_charge.form.price_placeholder')}
                  type="number"
                  pattern="[\d\.]*"
                  step="0.01"
                  name="amount"
                />
              </div>
              <div className="layout__item u-1/3-large-and-up">
                <span className="c-label-new u-inline-block">{t('register:custom_charge.form.barber_label')}</span>
                <Select
                  name="barberId"
                  className="c-input c-input--white"
                  options={barbers}
                  valueField="id"
                  textField={barber => fullName(barber)}
                  {...(isUnassignedChargeAvailable && { empty: t('register:custom_charge.form.unassigned_option') })}
                />
              </div>
            </div>
            <div className="c-separator u-mv" />
            <div className="u-text-right">
              <button
                type="submit"
                className="c-btn c-btn--medium u-width-120"
                disabled={pristine || !valid}
                name="chargeCB"
                onClick={handleSubmit(trimFunction(charge))}
              >
                <span className="c-btn__text">{t('register:custom_charge.form.charge_button')}</span>
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  </div>
);
Form.propTypes = {
  handleSubmit: shapes.handler,
  charge: shapes.handler.isRequired,
  pristine: shapes.pristine,
  submitting: shapes.submitting,
  valid: shapes.valid,
  barbers: shapes.barbers,
  isUnassignedChargeAvailable: PropTypes.bool,
};
Form.defaultProps = {
  handleSubmit: () => null,
  pristine: false,
  submitting: false,
  valid: false,
  isUnassignedChargeAvailable: true,
  barbers: [],
};

export default Form;
